import {
  discoveryApiRef,
  fetchApiRef,
  ApiBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { secretsStorageApiRef } from '@internal/backstage-plugin-devops-secrets-storage-react';
import { SecretsStorageApiClient } from './api';

const secretsStorageApi = ApiBlueprint.make({
  name: 'secretsStorageApi',
  params: defineParams =>
    defineParams({
      api: secretsStorageApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new SecretsStorageApiClient(discoveryApi, fetchApi),
    }),
});

export const devopsSecretsStoragePlugin = createFrontendPlugin({
  pluginId: 'devops-secrets-storage',
  extensions: [secretsStorageApi],
});
